import React, { useEffect } from "react";
import facebook from "../img/social/facebook.png";
import x from "../img/social/twitter.png";
import linkedin from "../img/social/in.png";
import whatsapp from "../img/social/whatsapp-utpl.png";

const SocialShare = ({ title, url, imageUrl }) => {
  
  // Efecto para inyectar etiquetas meta si no tienes acceso al head directamente
  useEffect(() => {
    if (!url || !imageUrl) return;

    const createOrUpdateMeta = (property, content, isName = false) => {
      const attr = isName ? "name" : "property";
      let element = document.querySelector(`meta[${attr}="${property}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attr, property);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    // Open Graph (Facebook, LinkedIn, WhatsApp)
    createOrUpdateMeta("og:title", title);
    createOrUpdateMeta("og:url", url);
    createOrUpdateMeta("og:image", imageUrl);
    createOrUpdateMeta("og:type", "article");

    // Twitter Cards
    createOrUpdateMeta("twitter:card", "summary_large_image", true);
    createOrUpdateMeta("twitter:title", title, true);
    createOrUpdateMeta("twitter:image", imageUrl, true);

  }, [title, url, imageUrl]);

  // URLs de compartición
  const socialLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(title + " " + url)}`,
  };

  const handleShare = (link) => {
    window.open(link, "_blank", "width=600,height=400");
  };

  return (
    <div className="wrapper-social-noticias">
      <button onClick={() => handleShare(socialLinks.whatsapp)} title="Compartir en WhatsApp">
        <img src={whatsapp} alt="WhatsApp UTPL" />
      </button>
      <button onClick={() => handleShare(socialLinks.twitter)} title="Compartir en X">
        <img src={x} alt="X" />
      </button>
      <button onClick={() => handleShare(socialLinks.linkedin)} title="Compartir en LinkedIn">
        <img src={linkedin} alt="LinkedIn" />
      </button>
      <button onClick={() => handleShare(socialLinks.facebook)} title="Compartir en Facebook">
        <img src={facebook} alt="Facebook" />
      </button>
    </div>
  );
};

export default SocialShare;